import { useSelector } from 'react-redux';
import { isPmToolAzureBoardsSelector } from 'state/selectors/sensors-authorizations';
import { pmFiltersBuilder } from 'components/FilterMenus/pm.filters';
import { PM_PROVIDERS } from 'common/constants/constants';
import useSettingsService from 'components/hooks/useSettingsService';
import { FILTER_TYPES } from 'common/constants/filters';

const useMenuItems = () => {
  const isPmToolAzureBoards = useSelector(isPmToolAzureBoardsSelector);

  const { getSettingOrDefinitionValue } = useSettingsService();

  const menuItemsV2 = pmFiltersBuilder(
    {
      [PM_PROVIDERS.JIRA]: [
        FILTER_TYPES.ISSUE_TYPES,
        FILTER_TYPES.LABEL,
        FILTER_TYPES.FIELD
      ],
      [PM_PROVIDERS.AZURE_BOARDS]: [
        FILTER_TYPES.ISSUE_TYPES,
        FILTER_TYPES.LABEL,
        FILTER_TYPES.FIELD
      ],
      [PM_PROVIDERS.CLUBHOUSE]: [FILTER_TYPES.ISSUE_TYPES, FILTER_TYPES.LABEL]
    },
    getSettingOrDefinitionValue
  );

  const defaultMenuItems = [
    { title: 'Issue Types', id: FILTER_TYPES.ISSUE_TYPES },
    { title: 'Label', id: FILTER_TYPES.LABEL },
    { title: 'Field', id: FILTER_TYPES.FIELD }
  ];

  const azureBoardsMenuItems = [
    { title: 'Work Item', id: FILTER_TYPES.ISSUE_TYPES },
    { title: 'Tag', id: FILTER_TYPES.LABEL },
    { title: 'Field', id: FILTER_TYPES.FIELD }
  ];

  const menuItems = isPmToolAzureBoards
    ? azureBoardsMenuItems
    : defaultMenuItems;

  const customFieldsMapper = isPmToolAzureBoards
    ? {
        [FILTER_TYPES.ISSUE_TYPES]: 'Work Items',
        [FILTER_TYPES.LABEL]: 'Tags'
      }
    : {};

  return {
    menuItems,
    customFieldsMapper,
    menuItemsV2
  };
};

export default useMenuItems;
